module.exports = __webpack_public_path__ + "556724d45b0f9d86624303851213c29f.json";


//////////////////
// WEBPACK FOOTER
// ./src/portal/i18n/ja.json
// module id = 1042
// module chunks = 0